export const SAMPLE_NAMES = [
	// Dutch Names
	"Jan",
	"Piet",
	"Klaas",
	"Henk",
	"Willem",
	"Anna",
	"Maria",
	"Johanna",
	"Cornelia",
	"Elisabeth",
	"Gerard",
	"Hendrik",
	"Jacob",
	"Karel",
	"Lucas",
	"Margriet",
	"Petra",
	"Ria",
	"Sanne",
	"Tineke",
	"Adriaan",
	"Bart",
	"Dirk",
	"Erik",
	"Frans",
	"Gert",
	"Hans",
	"Ivo",
	"Jeroen",
	"Koen",

	// English Names
	"John",
	"Mary",
	"James",
	"Patricia",
	"Robert",
	"Jennifer",
	"Michael",
	"Linda",
	"William",
	"Elizabeth",
	"David",
	"Barbara",
	"Richard",
	"Susan",
	"Joseph",
	"Jessica",
	"Thomas",
	"Sarah",
	"Charles",
	"Karen",
	"Christopher",
	"Nancy",
	"Daniel",
	"Lisa",
	"Matthew",
	"Margaret",
	"Anthony",
	"Betty",
	"Mark",
	"Sandra",

	// German Names
	"Hans",
	"Maria",
	"Peter",
	"Anna",
	"Michael",
	"Elisabeth",
	"Thomas",
	"Ursula",
	"Andreas",
	"Monika",
	"Wolfgang",
	"Sabine",
	"Klaus",
	"Petra",
	"Jürgen",
	"Renate",
	"Dieter",
	"Angelika",
	"Manfred",
	"Brigitte",
	"Frank",
	"Claudia",
	"Bernd",
	"Gabriele",
	"Helmut",
	"Heike",
	"Karl",
	"Karin",
	"Ludwig",
	"Martina",

	// French Names
	"Jean",
	"Marie",
	"Pierre",
	"Sophie",
	"Michel",
	"Julie",
	"Philippe",
	"Céline",
	"Nicolas",
	"Isabelle",
	"François",
	"Nathalie",
	"Claude",
	"Caroline",
	"Jacques",
	"Laurence",
	"Patrick",
	"Valérie",
	"Daniel",
	"Sandrine",
	"Bernard",
	"Catherine",
	"Robert",
	"Christine",
	"Paul",
	"Martine",
	"Louis",
	"Anne",
	"Henri",
	"Élisabeth",

	// Spanish Names
	"José",
	"María",
	"Juan",
	"Carmen",
	"Antonio",
	"Isabel",
	"Manuel",
	"Ana",
	"Francisco",
	"Rosa",
	"Carlos",
	"Laura",
	"Miguel",
	"Patricia",
	"Luis",
	"Marta",
	"Javier",
	"Sara",
	"Pedro",
	"Elena",
	"Ángel",
	"Cristina",
	"Fernando",
	"Lucía",
	"Diego",
	"Paula",
	"Alberto",
	"Silvia",
	"David",
	"Natalia",

	// Italian Names
	"Giuseppe",
	"Maria",
	"Antonio",
	"Anna",
	"Giovanni",
	"Giuseppina",
	"Francesco",
	"Rosa",
	"Angelo",
	"Angela",
	"Salvatore",
	"Teresa",
	"Mario",
	"Lucia",
	"Luigi",
	"Carmela",
	"Vincenzo",
	"Giovanna",
	"Pietro",
	"Rita",
	"Carlo",
	"Antonietta",
	"Domenico",
	"Caterina",
	"Paolo",
	"Concetta",
	"Bruno",
	"Francesca",
	"Roberto",
	"Elisabetta",

	// Scandinavian Names
	"Johan",
	"Anna",
	"Erik",
	"Maria",
	"Lars",
	"Karin",
	"Anders",
	"Eva",
	"Per",
	"Elisabeth",
	"Nils",
	"Birgitta",
	"Karl",
	"Ingrid",
	"Gustav",
	"Margareta",
	"Oscar",
	"Astrid",
	"Axel",
	"Helena",
	"Viktor",
	"Sofia",
	"Emil",
	"Alice",
	"Hugo",
	"Maja",
	"Albin",
	"Ella",
	"Vilhelm",
	"Alma",

	// Eastern European Names
	"Ivan",
	"Maria",
	"Petr",
	"Anna",
	"Sergey",
	"Olga",
	"Dmitriy",
	"Natalia",
	"Andrey",
	"Elena",
	"Alexey",
	"Tatiana",
	"Mikhail",
	"Irina",
	"Vladimir",
	"Svetlana",
	"Nikolay",
	"Yulia",
	"Pavel",
	"Ekaterina",
	"Boris",
	"Anastasia",
	"Konstantin",
	"Daria",
	"Roman",
	"Polina",
	"Artem",
	"Kristina",
	"Denis",
	"Valentina",

	// Asian Names
	"Wei",
	"Ying",
	"Jin",
	"Mei",
	"Hiroshi",
	"Yuki",
	"Kenji",
	"Aiko",
	"Raj",
	"Priya",
	"Sanjay",
	"Anita",
	"Vikram",
	"Deepa",
	"Arun",
	"Neha",
	"Suresh",
	"Pooja",
	"Rahul",
	"Divya",
	"Amit",
	"Ritu",
	"Sunil",
	"Kavita",
	"Ravi",
	"Shweta",
	"Naveen",
	"Anjali",
	"Kiran",
	"Sonia",

	// Middle Eastern Names
	"Mohammed",
	"Fatima",
	"Ahmed",
	"Aisha",
	"Ali",
	"Zainab",
	"Omar",
	"Mariam",
	"Khalid",
	"Layla",
	"Hassan",
	"Noor",
	"Ibrahim",
	"Safiya",
	"Yusuf",
	"Amina",
	"Hamza",
	"Huda",
	"Zakariya",
	"Yasmin",
	"Tariq",
	"Nadia",
	"Rashid",
	"Samira",
	"Karim",
	"Leila",
	"Jamal",
	"Farida",
	"Malik",
	"Zara",

	// African Names
	"Kwame",
	"Ama",
	"Kofi",
	"Abena",
	"Kwesi",
	"Akua",
	"Kwaku",
	"Yaa",
	"Kwabena",
	"Afua",
	"Mamadou",
	"Aminata",
	"Ibrahim",
	"Fatoumata",
	"Omar",
	"Mariam",
	"Amadou",
	"Aissatou",
	"Boubacar",
	"Hawa",
	"Sekou",
	"Fanta",
	"Moussa",
	"Kadiatou",
	"Lamine",
	"Maimouna",
	"Cheikh",
	"Aminata",
	"Modou",
	"Aminata",

	// Latin American Names
	"Carlos",
	"Maria",
	"Juan",
	"Ana",
	"Miguel",
	"Sofia",
	"Jose",
	"Isabella",
	"Luis",
	"Valentina",
	"Pedro",
	"Camila",
	"Ricardo",
	"Gabriela",
	"Fernando",
	"Laura",
	"Roberto",
	"Carolina",
	"Daniel",
	"Mariana",
	"Alejandro",
	"Daniela",
	"Eduardo",
	"Paula",
	"Rafael",
	"Juliana",
	"Diego",
	"Andrea",
	"Manuel",
	"Natalia",
];
